"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  get: function get(input) {
    var client = this.context.get(['client']);
    if (input) {
      if (typeof input === 'string' && typeof client.get === 'function') {
        return client.get(input);
      }
      if (typeof input === 'function') {
        return input();
      }
    }
    return input;
  },
  json_decode: function json_decode(str) {
    return JSON.parse(str);
  }
};